import React from 'react'

function TraQual() {
    const style = {
        display: 'flex',
        alignItems: 'center',
        flexDirection:'column'
    }
  return (
      <div style={style}>
          <h1>
              تقدم الخدمة للشركات الكبيرة Service for large companies 
          </h1>
          <p>
              تقديم برامج تدريبية وتأهيلية مخصصة لتلبية احتياجات الشركات
              <br/>
              الكبيرة، مع التركيز على تطوير مهارات الموظفين وتعزيز فعالية العمل
              <br/>
              والتنمية المستدامة للكوادر البشرية
          </p>
    </div>
  )
}

export default TraQual